import { render, staticRenderFns } from "./FieldsTable.vue?vue&type=template&id=2f3e6b61&scoped=true"
import script from "./FieldsTable.vue?vue&type=script&lang=js"
export * from "./FieldsTable.vue?vue&type=script&lang=js"
import style0 from "./FieldsTable.vue?vue&type=style&index=0&id=2f3e6b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e6b61",
  null
  
)

export default component.exports